/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ReportDefs from './defs.defs.js'

const $nsid = 'tools.ozone.report.createActivity'

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  reportId: /*#__PURE__*/ l.integer(),
  activity: /*#__PURE__*/ l.typedUnion(
    [
      /*#__PURE__*/ l.typedRef<ReportDefs.QueueActivity>(
        (() => ReportDefs.queueActivity) as any,
      ),
      /*#__PURE__*/ l.typedRef<ReportDefs.AssignmentActivity>(
        (() => ReportDefs.assignmentActivity) as any,
      ),
      /*#__PURE__*/ l.typedRef<ReportDefs.EscalationActivity>(
        (() => ReportDefs.escalationActivity) as any,
      ),
      /*#__PURE__*/ l.typedRef<ReportDefs.CloseActivity>(
        (() => ReportDefs.closeActivity) as any,
      ),
      /*#__PURE__*/ l.typedRef<ReportDefs.ReopenActivity>(
        (() => ReportDefs.reopenActivity) as any,
      ),
      /*#__PURE__*/ l.typedRef<ReportDefs.NoteActivity>(
        (() => ReportDefs.noteActivity) as any,
      ),
    ],
    false,
  ),
  internalNote: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  publicNote: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  isAutomated: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.boolean(), false),
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  activity: /*#__PURE__*/ l.ref<ReportDefs.ReportActivityView>(
    (() => ReportDefs.reportActivityView) as any,
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Register an activity on a report. For state-change activity types, validates the transition and updates report.status atomically. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'ReportNotFound',
  'InvalidStateTransition',
  'AlreadyInTargetState',
])

export { main }

export const $lxm = $nsid
